import React, { useEffect } from 'react';
import 'css/EventItemContainer/GroupEventItem.scss';
import {
    GAMES_WITH_1X2,
    MARKET_SUB_TYPE,
    SPORTS,
} from '../../constants/appConfig';
import { isEventInclude1X2market } from '../../utils/Helper';
import ViewEventListItem from '../ViewEventListItem';
import classNames from 'classnames';
import { detectMobile } from '../../utils/UiHelper';

const GroupEventItem = ({
    events,
    showFavorites,
    limit,
    trackClickEvent,
    userId = 0,
    isLive,
}) => {
    const isMobile = detectMobile();
    let vinderspilQuantity = 0;

    if (event?.marketList?.length) {
        event.marketList.map((item) => {
            if (item.type === 'Vinderspil') {
                vinderspilQuantity++;
            }
        });
    }

    const isEventFromButton = (target, currentTarget) => {
        while (target && target !== currentTarget) {
            if (target.tagName === 'BUTTON') {
                return true;
            }
            target = target.parentNode;
        }
        return false;
    };
    const handleItemClick = (data, e) => {
        if (
            (e.currentTarget === e.target ||
                !isEventFromButton(e.target, e.currentTarget)) &&
            !events[0].vaixIndex
        ) {
            e.preventDefault();
            e.stopPropagation();
            const path = window.location.pathname;
            let widgetType;
            if (events[0].live && isLive) {
                widgetType =
                    'sr-widget:livepagebetrecommendation.eventlist:recommended';
            } else if (events[0].live) {
                widgetType =
                    'sr-widget:livebetrecommendation.eventlist:recommended';
            } else {
                widgetType =
                    'sr-widget:prematchbetrecommendation.eventlist:recommended';
            }
            if (typeof trackClickEvent === 'function') {
                trackClickEvent(
                    'clicks:event',
                    `sr:match:${data.externalId}`,
                    'event_id',
                    widgetType,
                    path,
                    userId || 0
                );
            }
        }
    };

    const _getSubheader = (options, className = '') => {
        return (
            <div className={className}>
                {options['2'] ? (
                    <div className="text-center col-33 float-right">2</div>
                ) : !options['2'] && options['X'] ? (
                    <div className="text-center col-33 float-right market-label-placeholder">
                        &nbsp;
                    </div>
                ) : null}
                {options['X'] ? (
                    <div className="text-center col-33 float-right">X</div>
                ) : null}
                {options['1'] && !options['X'] && !options['2'] ? (
                    <div className="text-center col-33 float-right market-label-placeholder">
                        &nbsp;
                    </div>
                ) : null}
                {options['1'] ? (
                    <div className="text-center col-33 float-right">1</div>
                ) : (
                    <div className="text-center col-33 float-right market-label-placeholder">
                        &nbsp;
                    </div>
                )}
            </div>
        );
    };

    const getHeader = (events, options) => {
        const isFootball = events && events[0].sportId === SPORTS.FOOTBALL;
        const isLive = events[0]?.live;

        if (options['1'] || options['X'] || options['2']) {
            return (
                <div className="view-event-list-subtitle row">
                    <div
                        className={classNames('three-dots', {
                            'col-4': !detectMobile(),
                            'col-45': detectMobile(),
                        })}
                    >
                        <span className="pl10">
                            {`${events[0]?.sport} / ${events[0]?.groupName} / ${
                                events[0]?.competition
                            }`}
                            {/*${getPeriodLength(events)}*/}
                            {/*{events[0].sport} / {events[0].groupName} /{' '}
                            {events[0]?.competition} {getPeriodLength(events)}*/}
                        </span>
                    </div>

                    {isMobile &&
                        _getSubheader(
                            options,
                            'primary-bet-label-section row col-55'
                        )}

                    {!isMobile && (
                        <div className="col-5 row">
                            {_getSubheader(
                                options,
                                classNames('primary-bet-label-section', {
                                    'col-55': isFootball,
                                })
                            )}
                            {events &&
                                isFootball && (
                                    <>
                                        <div className="col-05">&nbsp;</div>
                                        <div className="col-4 row">
                                            <div className="text-center">
                                                Antal mål i kampen
                                            </div>
                                        </div>
                                    </>
                                )}
                        </div>
                    )}
                </div>
            );
        } else {
            return (
                <div className="view-event-list-subtitle row">
                    <div className="col-5 three-dots">
                        <span className="pl10">
                            {`${events[0]?.sport} / ${events[0]?.groupName} / ${
                                events[0]?.competition
                            }`}
                            {/*${getPeriodLength(events)}*/}
                        </span>
                    </div>
                    <div className="col-4 row" />
                </div>
            );
        }
    };
    /*const getOptions = (event) => {
        let options = {
            1: false,
            X: false,
            2: false,
        };

        if (
            event &&
            GAMES_WITH_1X2.includes(event.sportId) &&
            event.marketList &&
            isEventInclude1X2market(event[0])
        ) {
            options['1'] = true;
            options['2'] = true;
            options['X'] = true;
        } else if (
            event &&
            event.marketList &&
            isEventInclude1X2market(event[0])
        ) {
            options['1'] = true;
            options['2'] = true;
        }
        return options;
    };*/

    let eventCounter = 0;

    const _splitEventsByAwayTeam = (events) => {
        let eventsWithAwayTeam = [],
            eventsWithoutAwayTeam = [];

        events.map((item) => {
            if (item.awayTeam !== null) {
                eventsWithAwayTeam.push(item);
            } else {
                eventsWithoutAwayTeam.push(item);
            }
        });

        return {
            eventsWithAwayTeam: eventsWithAwayTeam,
            eventsWithoutAwayTeam: eventsWithoutAwayTeam,
        };
    };

    const _getList = (listType, events) => {
        let res = {
            header: {
                1: false,
                X: false,
                2: false,
            },
            view: [],
            marketSubType: null,
        };

        if (
            events &&
            GAMES_WITH_1X2.includes(events[0].sportId) &&
            events[0].marketList &&
            isEventInclude1X2market(events[0])
        ) {
            res.header['1'] = true;
            res.header['2'] = true;
            res.header['X'] = true;
        } else if (
            events &&
            events[0].marketList &&
            isEventInclude1X2market(events[0])
        ) {
            res.header['1'] = true;
            res.header['2'] = true;
        }

        let {
            eventsWithAwayTeam,
            eventsWithoutAwayTeam,
        } = _splitEventsByAwayTeam(events);

        eventsWithAwayTeam.filter((item) => {
            //if event not 'live' then kickoff should be greater than current time
            return item?.liveScore || item?.kickoff > Date.now();
        });
        let eventIds = [];

        res.view = eventsWithAwayTeam.map((event, index) => {
            if (
                event &&
                event?.marketList &&
                (!limit || eventCounter < limit)
            ) {
                let markets = event.marketList.filter(
                    (market) =>
                        event.defaultMarketId === market.marketId ||
                        market.mainMarket === 1 ||
                        market.marketName === 'Vinder'
                );

                if (markets[0] && markets[0].itemList) {
                    if (!res.marketSubType) {
                        res.marketSubType = markets[0].marketSubType;
                    }
                    markets[0].itemList.map((item) => {
                        if (item?.bet === '1' && item?.odds > 1) {
                            res.header['1'] = true;
                        } else if (
                            item?.bet?.toUpperCase() === 'X' &&
                            item?.odds > 1
                        ) {
                            res.header['X'] = true;
                        } else if (item.bet === '2' && item.odds > 1) {
                            res.header['2'] = true;
                        }

                        return item;
                    });
                }

                if (eventIds.indexOf(event.eventId) === -1) {
                    eventIds.push(event.eventId);
                    eventCounter++;
                    return (
                        <li
                            className="view-event-list-item-wrapper"
                            key={index}
                            onClick={(e) => handleItemClick(event, e)}
                        >
                            <ViewEventListItem
                                userId={userId}
                                header={res.header}
                                event={event}
                                showFavorites={showFavorites}
                            />
                        </li>
                    );
                }
            }

            return (
                <li
                    className="view-event-list-item-wrapper"
                    key={event?.eventId}
                    onClick={(e) => handleItemClick(event, e)}
                >
                    <ViewEventListItem
                        userId={userId}
                        header={res.header}
                        event={event}
                        showFavorites={showFavorites}
                    />
                </li>
            );
        });

        let withoutAwayTeamViews = eventsWithoutAwayTeam.map((event) => {
            if (!res.marketSubType && event.marketList && event.marketList[0]) {
                res.marketSubType = event.marketList[0].marketSubType;
            }
            let isVinderspil =
                event &&
                event.marketList &&
                event.marketList[0] &&
                event.marketList[0].marketTypeName &&
                event.marketList[0].marketTypeName.indexOf('Vinderspil') > -1;
            if (eventIds.indexOf(event.eventId) === -1) {
                eventIds.push(event.eventId);

                /* show '1x2' marks in header only if it is not 'vinderspil' */
                if (!isVinderspil) {
                    res.header = {
                        1: true,
                        X: true,
                        2: true,
                    };
                }
                return (
                    <li
                        className="view-event-list-item-wrapper"
                        key={event.eventId}
                        onClick={(e) => handleItemClick(event, e)}
                    >
                        <ViewEventListItem
                            userId={userId}
                            header={res.header}
                            event={event}
                            showFavorites={showFavorites}
                        />
                    </li>
                );
            } else {
                return (
                    <li
                        className="view-event-list-item-wrapper"
                        key={event.eventId}
                        onClick={(e) => handleItemClick(event, e)}
                    >
                        <ViewEventListItem
                            userId={userId}
                            header={res.header}
                            event={event}
                            showFavorites={showFavorites}
                        />
                    </li>
                );
            }
        });

        res.view = res.view.concat(withoutAwayTeamViews);

        return res;
    };
    const isLivePageLocation = () => {
        return window.location.pathname === '/live';
    };

    const isFavoriteIconShow = (isLive) => {
        return isLive && isLivePageLocation();
    };

    const eventsList = _getList('splitter', events);
    const headerView = getHeader(events, eventsList.header);

    const betsAvailable = [
        eventsList.header['1'],
        eventsList.header['X'],
        eventsList.header['2'],
    ].filter((item) => item).length;

    return events ? (
        <div className={'view-event-list simplified'}>
            <div
                className={classNames('view-event-list-row-item ', {
                    mobile: detectMobile(),
                    'market-1x2':
                        eventsList.marketSubType === MARKET_SUB_TYPE.MAIN_1X2,
                    'no-bets': betsAvailable === 0,
                    'one-bet': betsAvailable === 1,
                    'two-bets': betsAvailable === 2,
                    'with-favicon': isFavoriteIconShow(
                        event?.live && event?.liveScore
                    ),
                })}
            >
                {headerView}
                <ul className="view-event-list-wrapper">{eventsList.view}</ul>
            </div>
        </div>
    ) : null;
};

export default GroupEventItem;
